import PublicCreateClaimContractSearch from '../../publicWeb/createClaim/steps/ContractSearch';
import PublicCreateClaimSubmissionDetails from '../../publicWeb/createClaim/steps/SubmissionDetails';
import { PublicCreateClaimProvider } from '../../publicWeb/createClaim/Hooks';
import usePageRouter from 'assets/hooks/pageRouter/usePageRouter';
import PublicCreateClaimClaimInfo from '../../publicWeb/createClaim/steps/ClaimInfo';
import PublicCreateClaimAddJob from '../../publicWeb/createClaim/steps/JobInfo';
import { getLocales } from 'assets/locales/Locale';
import PublicCreateClaimReview from '../../publicWeb/createClaim/steps/Review';
import Icon from 'assets/components/icon/Icon';
import PublicCreateClaimFinish from '../../publicWeb/createClaim/steps/Finish';
import DataMap from 'assets/components/dataMap/DataMap';
import Page from 'assets/components/page/Page';
import Button from 'assets/components/button/Button';
import Theme from 'assets/themes/Theme.Common';
import Box from 'assets/components/box/Box';
import ThemePageCentered from 'assets/components/page/themes/Theme.Page.Centered';
import ThemeWrapperSteps from 'assets/themes/wrappers/Theme.Wrapper.Steps';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import { claimsHomeRoute } from 'config/Api.Config';
import { useEffect } from 'react';
import { getConfig } from 'config';

export const claimCreateIndexRoute = claimsHomeRoute + '/create-claim';

export function useClaimCreatePageRouter() {
  return usePageRouter<undefined, Module.Claims.Claim.Submit.FormQuery>({ route: claimCreateIndexRoute });
}

export default function ClaimCreateIndex() {
  const { lang } = getLocales();

  useEffect(() => {
    const config = getConfig();
    gtag('event', 'portal_visit', { portal_entry: 'public_claim_new', env: config.env });
  }, []);

  return (
    <PublicCreateClaimProvider
      render={({ currentStep, setCurrentStep, isCurrentStepValidated, steps, form }) => (
        <Page
          class={ThemePageCentered}
          header={lang.publicSearchContractTitle}
          subHeader={
            <div className={ThemeWrapperSteps}>
              <DataMap
                data={steps}
                render={({ data: step }) => (
                  <div id={step.id.toString()} data-active={step.id === currentStep ? true : undefined}>
                    {step.title}
                  </div>
                )}
              />
            </div>
          }
          footer={
            <Box style={{ justifyContent: 'space-between', display: 'flex', maxWidth: 1100, margin: 'auto' }}>
              <Button
                class={ThemeButtonCircle}
                style={{
                  backgroundColor: currentStep === 4 ? Theme.Color.error : undefined,
                }}
                disabled={currentStep === 1 || currentStep === 6}
                onClick={currentStep === 1 || currentStep === 6 ? undefined : () => setCurrentStep(currentStep - 1)}
              >
                {lang.prev}
              </Button>
              {currentStep < 5 && (
                <Button
                  class={ThemeButtonCircle}
                  disabled={!isCurrentStepValidated}
                  active={isCurrentStepValidated}
                  onClick={!isCurrentStepValidated ? undefined : () => setCurrentStep(currentStep + 1)}
                >
                  {lang.next}
                </Button>
              )}
              {currentStep >= 5 && (
                <Button
                  class={ThemeButtonCircle}
                  onClick={
                    form.hasErrors || !form.isUpdated || form.isSubmitted || currentStep === 6 ? undefined : form.submit
                  }
                  disabled={form.hasErrors || !form.isUpdated || form.isSubmitted || currentStep === 6}
                  active={!(form.hasErrors || !form.isUpdated || form.isSubmitted || currentStep === 6)}
                  isLoading={form.isSubmitted && !form.isFinished}
                >
                  {lang.finish}
                  {form.data.claimDocuments.length > 0 && (
                    <>
                      &nbsp;+&nbsp;{form.data.claimDocuments.length}
                      &nbsp;
                      <Icon class="fas-paperclip" />
                    </>
                  )}
                </Button>
              )}
            </Box>
          }
        >
          {currentStep == 1 && <PublicCreateClaimContractSearch />}
          {currentStep == 1 && !!form.data.claim?.contract && <PublicCreateClaimSubmissionDetails />}
          {currentStep == 2 && <PublicCreateClaimClaimInfo />}
          {currentStep == 4 && <PublicCreateClaimAddJob />}
          {currentStep == 5 && <PublicCreateClaimReview />}
          {currentStep == 6 && <PublicCreateClaimFinish />}
        </Page>
      )}
    />
  );
}
